export const ACCESS_TOKEN = "accessToken";
export const firstCap = (string) =>
  string?.charAt(0)?.toUpperCase() + string?.slice(1);